{
    "table_header__location": "Standort",
    "table_header__unit": "Einheit",
    "table_header__inventory": "Bestand",
    "table_header__reserved": "Reserviert",
    "table_header__picked": "Kommissioniert",
    "table_header__effective_inventory": "Frei verfügbar"
}
